const comments = {
  namespaced: true,
  state: {
    currentComment: null
  },
  getters: {
    currentComment: (state) => state.currentComment
  },
  mutations: {
    changeCurrentComment(state, comment) {
      state.currentComment = comment;
    }
  },
  actions: {
    changeCurrentComment({ commit }, comment) {
      commit("changeCurrentComment", comment);
    }
  }
};
export {
  comments as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbWVudHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdG9yZS9jb21tZW50cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gICAgbmFtZXNwYWNlZDogdHJ1ZSxcbiAgICBzdGF0ZToge1xuICAgICAgICBjdXJyZW50Q29tbWVudDogbnVsbCxcbiAgICB9LFxuICAgIGdldHRlcnM6IHtcbiAgICAgICAgY3VycmVudENvbW1lbnQ6IChzdGF0ZSkgPT4gc3RhdGUuY3VycmVudENvbW1lbnQsXG4gICAgfSxcbiAgICBtdXRhdGlvbnM6IHtcbiAgICAgICAgY2hhbmdlQ3VycmVudENvbW1lbnQoc3RhdGUsIGNvbW1lbnQpIHtcbiAgICAgICAgICAgIHN0YXRlLmN1cnJlbnRDb21tZW50ID0gY29tbWVudDtcbiAgICAgICAgfVxuICAgIH0sXG4gICAgYWN0aW9uczoge1xuICAgICAgICBjaGFuZ2VDdXJyZW50Q29tbWVudCh7IGNvbW1pdCB9LCBjb21tZW50KSB7XG4gICAgICAgICAgICBjb21taXQoJ2NoYW5nZUN1cnJlbnRDb21tZW50JywgY29tbWVudClcbiAgICAgICAgfVxuICAgIH0sXG59O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQWUsV0FBQTtBQUFBLEVBQ1gsWUFBWTtBQUFBLEVBQ1osT0FBTztBQUFBLElBQ0gsZ0JBQWdCO0FBQUEsRUFDbkI7QUFBQSxFQUNELFNBQVM7QUFBQSxJQUNMLGdCQUFnQixDQUFDLFVBQVUsTUFBTTtBQUFBLEVBQ3BDO0FBQUEsRUFDRCxXQUFXO0FBQUEsSUFDUCxxQkFBcUIsT0FBTyxTQUFTO0FBQ2pDLFlBQU0saUJBQWlCO0FBQUEsSUFDbkM7QUFBQSxFQUNLO0FBQUEsRUFDRCxTQUFTO0FBQUEsSUFDTCxxQkFBcUIsRUFBRSxPQUFRLEdBQUUsU0FBUztBQUN0QyxhQUFPLHdCQUF3QixPQUFPO0FBQUEsSUFDbEQ7QUFBQSxFQUNLO0FBQ0w7In0=
